import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import _ from 'lodash';
import React from 'react';
import ScrollSpy from '../../../layouts/scrollspy';
import ListingBadge, { BADGE_ORDER_PRIORITY, BADGE_MODE } from './base';
import FullWidthBadge from './fullWidthBadge';
class CashOnlyBadge extends ListingBadge {
    static title = 'Cash Only';
    static titleIcon = 'money-bill';
    static contentPositive = false;
    static shouldBeIncluded(listing, badgeMode) {
        return (badgeMode === BADGE_MODE.EXPANDED &&
            !_.get(listing, 'listing_configuration.financing_available', false));
    }
    get content() {
        const trustee = _.get(this.props.listing, 'event.trustee_sale', false);
        return (_jsxs(_Fragment, { children: ["Conventional financing is ", _jsx("strong", { children: "NOT" }), " accepted for this property.", ' ', _jsx(ScrollSpy, { selector: '#prepare_your_finances', children: ({ scrollTo }) => (_jsx("a", { onClick: scrollTo, children: trustee ? 'What should I bring?' : 'Learn more' })) })] }));
    }
}
class FinancingAvailableBadge extends FullWidthBadge {
    static summary = 'Eligible for Financing';
    static titleIcon = 'money-bill';
    static condensedTitle = 'Financing Available';
    static renderPriority = BADGE_ORDER_PRIORITY.FIFTH;
    static shouldBeHoisted = true;
    static shouldBeIncluded(listing) {
        return _.get(listing, 'listing_configuration.financing_available', false);
    }
    get content() {
        return (_jsxs(_Fragment, { children: ["Buyers are responsible for determining financing eligibility prior to bidding.", ' ', _jsx(ScrollSpy, { selector: '#prepare_your_finances', children: ({ scrollTo }) => _jsx("a", { onClick: scrollTo, children: "Learn More" }) })] }));
    }
}
export { CashOnlyBadge, FinancingAvailableBadge };
//# sourceMappingURL=cashOnly.js.map